import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";
import {
    IPaymentDayType
} from "../../../../../../../utils/interfaces/my_documents/fiscal_registry/payment/IPaymentDayType";


const useApiGetPaymentDayTypes = (): UseQueryResult<IPaymentDayType[], CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(company_token: string | undefined): Promise<IPaymentDayType[]> {
        try {
            const response = await get(`/api/company/${company_token}/my_documents/payment/payment_day_type`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetPaymentDayTypes"],
        queryFn: () => doGet(selectedCompany?.company_token,),
    })
};

export default useApiGetPaymentDayTypes